"use client";

import { useEffect, useRef } from "react";
import styles from "./ProductDetailsPage.module.css";

const Indicators = ({ slides, sliderId }: { slides: number; sliderId: string }) => {
	const ref = useRef<HTMLDivElement>(null!);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		const controller = new AbortController();

		const slider = document.querySelector<HTMLElement>(`#${sliderId}`);
		const indicators = ref.current.querySelectorAll<HTMLSpanElement>("span");

		if (!slider) return;

		slider?.addEventListener(
			"scroll",
			() => {
				updateActiveIndicator();
			},
			{ signal: controller.signal },
		);

		function updateActiveIndicator() {
			const { scrollLeft, clientWidth } = slider!;
			const activeIndex = Math.round(scrollLeft / clientWidth);
			indicators?.forEach((indicator, index) => {
				if (index === activeIndex) {
					indicator.dataset.active = "true";
				} else {
					indicator.dataset.active = "false";
				}
			});
		}
		updateActiveIndicator();

		return () => {
			controller.abort();
		};
	}, [slides]);
	return (
		<div className={styles.indicators} ref={ref}>
			{Array.from({ length: slides }, (_, index) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
				<span className={styles.indicator} key={index} />
			))}
		</div>
	);
};

export default Indicators;
